/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { SelectButtonItem } from '../../../../../models/SelectButtonItem';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Product Type Condition Props.
 */
export interface ModeConditionProps {
  handleChange: (e: any, key: string) => void;
  modeOptions: SelectButtonItem[] | null;
}

/**
 * Mode Condition will display the filter depending on Mode selection.
 * @param handleChange Function to handle when a mode button is clicked.
 * @returns ModeCondition Element.
 */
export const ModeCondition = ({
  handleChange,
  modeOptions,
}: ModeConditionProps) => {
  /**
   * onChange Mode
   * @param value mode(s)
   */
  const onChangeMode = (value: string | number[]) => {
    handleChange(value, filterSections.visibility.param);
  };

  return (
    <div className="visibilityFilter">
      <CustomAccordion
        title={filterSections.visibility.title}
        children={
          <FilterSelectButtons
            name={filterSections.visibility.param}
            options={modeOptions ?? []}
            handleChange={onChangeMode}
          />
        }
      />
    </div>
  );
};
